const content: { [key: string]: any } = {
  awardLabels: {
    "no-pin-level": "--",
    "no-data-available": "No Data Available",
    diamond: "Diamond",
    "diamond-plus": "Diamond Plus",
    "founders-emerald": "Founders Emerald",
    emerald: "Emerald",
    "founders-sapphire": "Founders Sapphire",
    sapphire: "Sapphire",
    sapphireRequalification: "Sapphire Requalification",
    "founders-ruby": "Founders Ruby",
    ruby: "Ruby",
    "founders-platinum": "Founders Platinum",
    platinum: "Platinum",
    platinumRequalification: "Platinum Requalification",
    "gold-producer": "Gold Producer",
    "silver-producer": "Silver Producer",
    "silver-sponsor": "Silver Sponsor",
    associate: "Associate",
    "associate-not-qualified": "Not Qualified",
    "associate-tooltip": "Minimum Requirements Not Yet Met",
    inactive: "Inactive",
    member: "Member",
    "preferred-customer": "Preferred Customer",
    "founders-diamond": "Founders Diamond",
    "executive-diamond": "Executive Diamond",
    "founders-executive-diamond": "Founders Executive Diamond",
    "double-diamond": "Double Diamond",
    "founders-double-diamond": "Founders Double Diamond",
    "triple-diamond": "Triple Diamond",
    "founders-triple-diamond": "Founders Triple Diamond",
    crown: "Crown",
    "founders-crown": "Founders Crown",
    "crown-ambassador": "Crown Ambassador",
    "founders-crown-ambassador": "Founders Crown Ambassador",
    "percent-23": "23%",
    "percent-21": "21%",
    "percent-18": "18%",
    "percent-15": "15%",
    "percent-12": "12%",
    "percent-9": "9%",
    "percent-6": "6%",
    "percent-3": "3%",
    "23-percent": "23%",
    "21-percent": "21%",
    "18-percent": "18%",
    "15-percent": "15%",
    "12-percent": "12%",
    "9-percent": "9%",
    "6-percent": "6%",
    "3-percent": "3%",
    "not-available": "Not Available",
    "fca-40": "FCA 40",
    "fca-45": "FCA 45",
    "fca-50": "FCA 50",
    "fca-55": "FCA 55",
    "fca-60": "FCA 60",
    "fca-65": "FCA 65",
    "fca-70": "FCA 70",
    "not-tracking": "Not Tracking",
    ads: "ADS",
    adr: "ADR",
    pearl: "Pearl",
    extension: "or Above",
    "platinum-or-above": "Platinum or Above",
    "diamond-and-above": "Diamond and Above",
    "emerald-and-above": "Emerald and Above",
    "gar-executive-diamond": "GAR Executive Diamond",
    "gar-founders-executive-diamond": "GAR Founders Executive Diamond",
    "gar-double-diamond": "GAR Double Diamond",
    "gar-founders-double-diamond": "GAR Founders Double Diamond",
    "gar-triple-diamond": "GAR Triple Diamond",
    "gar-founders-triple-diamond": "GAR Founders Triple Diamond",
    "gar-crown": "GAR Crown",
    "gar-founders-crown": "GAR Founders Crown",
    "gar-crown-ambassador": "GAR Crown Ambassador",
    "gar-founders-crown-ambassador": "GAR Founders Crown Ambassador",
    silver: "Silver",
    silverRequalification: "Silver Requalification",
    gold: "Gold Producer",
    goldRequalification: "Gold Producer Requalification",
    foundersPlatinum: "Founders Platinum",
    foundersPlatinumRequalification: "Founders Platinum Requalification",
    foundersSapphire: "Founders Sapphire",
    foundersSapphireRequalification: "Founders Sapphire Requalification",
    inMarketEmerald: "Emerald",
    inMarketEmeraldRequalification: "Emerald Requalification",
    inMarketFoundersEmerald: "Founders Emerald",
    inMarketFoundersEmeraldRequalification: "Founders Emerald Requalification",
    inMarketDiamond: "Diamond",
    inMarketDiamondRequalification: "Diamond Requalification",
    inMarketFoundersDiamond: "Founders Diamond",
    inMarketFoundersDiamondRequalification: "Founders Diamond Requalification",
    a70InMarketEmerald: "A70 Emerald",
    a70InMarketEmeraldRequalification: "A70 Emerald Requalification",
    a70InMarketFoundersEmerald: "A70 Founders Emerald",
    a70InMarketFoundersEmeraldRequalification: "A70 Founders Emerald Requalification",
    a70InMarketDiamond: "A70 Diamond",
    a70InMarketDiamondRequalification: "A70 Diamond Requalification",
    a70InMarketFoundersDiamond: "A70 Founders Diamond",
    a70InMarketFoundersDiamondRequalification: "A70 Founders Diamond Requalification",
    chinaLabels: {
      "founders-crown-ambassador": "Founders Crown Ambassador",
      "crown-ambassador": "Crown Ambassador",
      "founders-crown": "Founders Crown",
      crown: "Crown",
      "founders-triple-diamond": "Founders Elite Sales Director",
      "triple-diamond": "Elite Sales Director",
      "founders-double-diamond": "Founders Senior Sales Director",
      "double-diamond": "Senior Sales Director",
      "founders-executive-diamond": "Founders Sales Director",
      "executive-diamond": "Sales Director",
      "founders-diamond": "Founders Senior Sales Manager",
      diamond: "Senior Sales Manager",
      "founders-platinum": "Founders Senior Sales Supervisor",
      "founders-emerald": "Founders Sales Manager",
      emerald: "Sales Manager",
    },
  },
  abbreviatedAwardLabels: {
    "0P": "0P",
    SI6: "SI6",
    SI4: "SI4",
    GLD: "GLD",
    DD: "DD",
    RBY: "RBY",
    FDD: "FDD",
    FRB: "FRB",
    PRL: "PRL",
    SPH: "SPH",
    FSP: "FSP",
    EM: "EM",
    FEM: "FEM",
    DIA: "DIA",
    FDI: "FDI",
    XDI: "XDI",
    FED: "FED",
    DDI: "DDI",
    F2D: "F2D",
    TDI: "TDI",
    F3D: "F3D",
    CRN: "CRN",
    FCN: "FCN",
    CAM: "CAM",
    FCA: "FCA",
    F40: "F40",
    F45: "F45",
    F50: "F50",
    F55: "F55",
    F60: "F60",
    F65: "F65",
    F70: "F70",
    "03P": "03P",
    "6P": "6P",
    "9P": "9P",
    "12P": "12P",
    "15P": "15P",
    "18P": "18P",
    "21P": "21P",
    "23P": "23P",
    GXD: "GXD",
    GFE: "GFE",
    G2D: "G2D",
    GF2: "GF2",
    GTD: "GTD",
    GF3: "GF3",
    GCN: "GCN",
    GFC: "GFC",
    GCA: "GCA",
    GFA: "GFA",
    diamond: "DIA",
    "founders-emerald": "FEM",
    emerald: "EM",
    "founders-sapphire": "FSP",
    sapphire: "SPH",
    "founders-ruby": "FRB",
    ruby: "RBY",
    "founders-platinum": "FDD",
    platinum: "DD",
    "gold-producer": "GLD",
    "silver-producer": "SI4",
    "silver-sponsor": "SSR",
    associate: "AS",
    inactive: "IA",
    member: "ME",
    "preferred-customer": "PC",
    "founders-diamond": "FDI",
    "executive-diamond": "XDI",
    "founders-executive-diamond": "FED ",
    "double-diamond": "DDI",
    "founders-double-diamond": "F2D",
    "triple-diamond": "TDI",
    "founders-triple-diamond": "F3D",
    crown: "CRN",
    "founders-crown": "FCN",
    "crown-ambassador": "CAM",
    "founders-crown-ambassador": "FCA",
    "percent-23": "23P",
    "percent-21": "21P",
    "percent-18": "18P",
    "percent-15": "15P",
    "percent-12": "12P",
    "percent-9": "09P",
    "percent-6": "06P",
    "percent-3": "03P",
    "23%": "23P",
    "21%": "21P",
    "18%": "18P",
    "15%": "15P",
    "12%": "12P",
    "9%": "09P",
    "6%": "06P ",
    "3%": "03P ",
    "not-available": "NA",
    "fca-40": "F40",
    "fca-45": "F45",
    "fca-50": "F50",
    "fca-55": "F55",
    "fca-60": "F60",
    "fca-65": "F65",
    "fca-70": "F70",
    "not-tracking": "NOT",
    ads: "ADS",
    adr: "ADR",
    pearl: "PRL",
    extension: "ORA",
    "platinum-or-above": "DDA",
  },
  chinaOverrideAwardLabels: {
    "founders-triple-diamond": "Founders Senior Marketing Director",
    "triple-diamond": "Senior Marketing Director",
    "founders-double-diamond": "Founders Advanced Marketing Director",
    "double-diamond": "Advanced Marketing Director",
    "founders-executive-diamond": "Founders Marketing Director",
    "executive-diamond": "Marketing Director",
    "founders-diamond": "Founders Senior Marketing Manager",
    diamond: "Senior Marketing Manager",
    "founders-platinum": "Founders Senior Marketing Supervisor",
    "founders-emerald": "Founders Marketing Manager",
    emerald: "Marketing Manager",
    crown: "Crown",
    "founders-crown": "Founders Crown",
    "crown-ambassador": "Crown Ambassador",
    "founders-crown-ambassador": "Founders Crown Ambassador",
  },
};

export default content;
